<ul class="parents-list" *ngIf="parents && parents.length > 0">
    <li *ngFor="let parent of parents; let i = index; let isLast = last">
        <h3>{{parent}} <span *ngIf="!isLast">></span></h3>
    </li>
</ul>

<location-details [location]="functionalLocation"></location-details>

<p *ngIf="!location">
    No location information available
</p>